export default {
  main: '#000000',
  secondary: '#DA291C',
  contrastingColor: '#ffffff',
  priceColor: '#DA291C',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
